import * as React from 'react';
import * as S from './styles';
import { IProps } from './types';
import HalfStarIcon from 'common/icons/halfStarIcon';
import QuarterStarIcon from 'common/icons/quarterStarIcon';
import ThreeQuartersStarIcon from 'common/icons/threeQuartersStarIcon';
import StarIcon from 'common/icons/starIcon';
import EmptytStarIcon from 'common/icons/emptyStarIcon';

type StarType = "complete" | "half" | "quarter" | "threeQuarters" | 'empty';

const StarsRating: React.FC<IProps> = (props) => {

    const { starColor } = props;

    const returnStarElement = (type: StarType) => {
        return (
            <S.StarContainer style={props.starStyle} >
                {type === "complete" ? <StarIcon fillColor={starColor} /> : (type === "half" ? <HalfStarIcon fillColor={starColor} /> : (type === "quarter" ? <QuarterStarIcon fillColor={starColor} /> : (type === "threeQuarters" ? <ThreeQuartersStarIcon fillColor={starColor} /> : <EmptytStarIcon fillColor={starColor} />)))}
            </S.StarContainer>
        );
    }

    const renderStars = () => {
        const averageRating = props.rating;
        let stars: JSX.Element[] = [];
        for (let i = 0; i < averageRating; i++) {
            const diff = averageRating - i;
            if (diff > 0.87) stars.push(returnStarElement("complete"));
            else if (diff > 0.62) stars.push(returnStarElement("threeQuarters"));
            else if (diff > 0.37) stars.push(returnStarElement("half"));
            else if (diff > 0.12) stars.push(returnStarElement("quarter"));
        }
        
        if (stars.length===0 && props.showEmptyStars) stars = new Array(5).fill(returnStarElement("empty"));
        return stars;
    }

    return (
        <S.Root>
            {renderStars()}
        </S.Root>
    );
}

export default StarsRating;
